/* RESPONSIBLE TEAM: team-standalone */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { buildValidations, validator } from 'ember-cp-validations';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { not } from '@ember/object/computed';
import { dependentKeyCompat } from '@ember/object/compat';
import { attr } from '@ember-data/model';
const Validations = buildValidations({
  zendeskConversationsApiIsConnectedForIntercomMessenger: [
    validator('zendesk-conversations-api-is-connected-for-intercom-messenger', {
      disabled: not('model.stepConfig.shouldCheckApiConnectionForIntercomMessenger'),
      dependentKeys: [
        'model.isConnectedForIntercomMessenger',
        'model.shouldCheckApiConnectionForIntercomMessenger',
      ],
      messageKey:
        'operator.workflows.visual-builder.handoff-to-zendesk-agent.requires-api-connection-validation-error-message',
    }),
  ],
});

export default class HandoffToZendeskAgent extends Step.extend(Validations) {
  @service declare finStandaloneService: FinStandaloneService;

  @attr('boolean') declare queueHandling: boolean;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.handoffToZendeskAgent;
  }

  @dependentKeyCompat
  get isConnectedForIntercomMessenger() {
    return this.finStandaloneService.zendeskConfig?.sunshineIntegration?.isSunshineConnected;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation];
  }

  static get isStepGroupEnding() {
    return true;
  }

  static get isStepTerminal() {
    return true;
  }

  static createNewStep(store: Store): HandoffToZendeskAgent {
    return store.createRecord('operator/visual-builder/step/handoff-to-zendesk-agent', {
      type: 'operator/visual-builder/step/handoff-to-zendesk-agent',
    });
  }
}
